import { MdClose, MdWarning } from 'react-icons/md';
import styles from './ConfirmModal.module.css';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>{title || 'Confirm'}</h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close confirmation modal"
          >
            <MdClose />
          </button>
        </div>

        <div className={styles.content}>
          <MdWarning className={styles.warningIcon} />
          <p className={styles.message}>{message}</p>
        </div>

        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.confirmBtn} onClick={onConfirm}>
            Override & Import
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
